<script setup lang="ts">
/**
 * Per-message token and latency attribution.
 *
 * Not a port, despite sharing the live viewer's name: that component displays a
 * separate streaming-text buffer, which this architecture does not have — the
 * reducer folds token deltas straight into the message's own content, so the
 * bubble *is* the ticker. What was missing, and what this is, is the usage
 * readout the specced component list asks for.
 */
import { computed } from 'vue';

import type { Usage } from '../types/message';

const props = defineProps<{ usage: Usage }>();

const parts = computed(() => {
  const out: string[] = [];
  if (props.usage.inputTokens) out.push(`${props.usage.inputTokens} in`);
  if (props.usage.outputTokens) out.push(`${props.usage.outputTokens} out`);
  if (props.usage.durationMs) {
    const ms = props.usage.durationMs;
    out.push(ms < 1000 ? `${ms}ms` : `${(ms / 1000).toFixed(1)}s`);
  }
  return out;
});
</script>

<template>
  <p
    v-if="parts.length"
    data-testid="token-ticker"
    class="text-[10px] text-gray-400 dark:text-gray-500"
  >
    {{ parts.join(' · ') }}
  </p>
</template>
